<template>
  <VRow align="center">
    <VCol
      cols="12"
      :md="$route.meta.iframe ? '12' : '6'"
      :offset-md="$route.meta.iframe ? '0' : '3'"
      class="text-center"
    >
      <div class="headline mb-5">
        {{ $t('tuneCamera') }}
      </div>
      <CameraCheck v-if="$route.meta.iframe" @checked="cameraChecked" />
      <VResponsive v-else :aspect-ratio="16 / 9">
        <CameraCheck @checked="cameraChecked" />
      </VResponsive>
      <p class="pt-md-2 mb-md-0 body-2">
        {{ $t('beSerious') }}:
      </p>
    </VCol>
    <VCol cols="12" class="pt-md-0 pb-md-0">
      <VRow justify="end" class="caption d-none d-md-flex mb-2">
        <VCol class="d-flex align-end justify-center py-md-0">
          <img src="../../assets/img/interview/look.svg">
        </VCol>
        <VCol class="d-flex align-end justify-center py-md-0">
          <img src="../../assets/img/interview/map-pointer.svg">
        </VCol>
        <VCol class="d-flex align-end justify-center py-md-0">
          <img src="../../assets/img/interview/sun.svg">
        </VCol>
        <VCol class="d-flex align-end justify-center py-md-0">
          <img src="../../assets/img/interview/camera-border.svg">
        </VCol>
      </VRow>
      <VRow justify="center" class="caption interview-recomendations">
        <VCol
          class="
            text-md-center
            d-flex
            flex-md-column
            align-md-center
            col-12
            col-md-3
          "
        >
          <img class="d-md-none mr-2" src="../../assets/img/interview/look.svg">
          <span>{{ $t('yourLook') }}</span>
        </VCol>
        <VCol class="text-md-center d-flex flex-md-column align-md-center col-12 col-md-3">
          <img class="d-md-none mr-2" src="../../assets/img/interview/map-pointer.svg">
          <span>{{ $t('quitePlace') }}</span>
        </VCol>
        <VCol class="text-md-center d-flex flex-md-column align-md-center col-12 col-md-3">
          <img class="d-md-none mr-2" src="../../assets/img/interview/sun.svg">
          <span>{{ $t('seenWell') }}</span>
        </VCol>
        <VCol class="text-md-center d-flex flex-md-column align-md-center col-12 col-md-3">
          <img class="d-md-none mr-2" src="../../assets/img/interview/camera-border.svg">
          <span>{{ $t('inCenter') }}</span>
        </VCol>
      </VRow>
    </VCol>
    <VCol cols="12" class="text-center mt-2">
      <VBtn id="startInterview" :disabled="!camera" color="success" @click="done">
        {{ $t('startInterview') }}
      </VBtn>
    </VCol>
  </VRow>
</template>

<script>
import CameraCheck from '@huntica/huntica-interview-module/src/components/CameraCheck.vue';
import {
  requestFullScreen, isAndroidTelegram, isIosOs,
} from '@huntica/huntica-interview-module/src/helpers';

export default {
  name: 'InterviewCameraCheck',
  components: {
    CameraCheck,
  },
  data() {
    return {
      camera: false,
    };
  },
  computed: {
    isAndroidTelegram() {
      return isAndroidTelegram();
    },
    isIosOs() {
      return isIosOs();
    },
  },
  methods: {
    cameraChecked(value) {
      this.camera = value;
    },
    async done() {
      try {
        if (this.isAndroidTelegram || this.isIosOs) {
          try {
            await requestFullScreen(document.querySelector('.full-screen-item'));
            await window.screen.orientation.lock('landscape-primary');
            // eslint-disable-next-line no-empty
          } catch (e) {

          }
        } else if ('onorientationchange' in window && !window.ManagedMediaSource && !this.isIosOs) {
          await requestFullScreen(document.querySelector('.full-screen-item'));
          await window.screen.orientation.lock('landscape-primary');
        }
        this.$emit('done');
      } catch (e) {
        throw e;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.interview-recomendations {
  img {
    width: 24px;
  }
}
</style>
<!-- TODO вот это должно быть в интервью модуле наверное -->
<i18n locale="en" lang="yaml">
  tuneCamera: Setup your camera
  beSerious: Take this online interview the same way as if you were in a face-to-face interview
  yourLook: Dress appropriately
  quitePlace: Find a quiet place with a neutral background
  seenWell: Sit facing the light, make sure you are clearly visible
  inCenter: Sit up straight so that your face is in the center of the camera
  startInterview: Start the video interview
</i18n>

<i18n locale="ru" lang="yaml">
  tuneCamera: Настройте камеру
  beSerious: Отнеситесь к виртуальному интервью так же, как к очной встрече с работодателем
  yourLook: Продумайте ваш внешний вид
  quitePlace: Выберите тихое место с нейтральным фоном
  seenWell: Сядьте лицом к свету, убедитесь, что ваc хорошо видно
  inCenter: Сидите ровно, так чтобы ваше лицо было в центре изображения с камеры
  startInterview: Начать видео-интервью
</i18n>
